import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '../hooks/useAnalytics';
import { useHotelConfig } from '../hooks/useHotelConfig';
import { logger } from '../lib/logger';

export const AnalyticsRouteTracker: React.FC = () => {
  const location = useLocation();
  const { id: hotelId, slug, baseUrl } = useHotelConfig();
  const analytics = useAnalytics();

  useEffect(() => {
    // Track page view on route change
    analytics.trackPageView();

    logger.debug('Page view tracked by AnalyticsRouteTracker', {
      category: 'Analytics',
      data: {
        path: location.pathname,
        title: document.title,
        hotelId,
        slug,
        baseUrl,
        timestamp: new Date().toISOString()
      }
    });
  }, [location.pathname, location.search, location.hash, hotelId, slug, baseUrl, analytics]);

  return null;
};

export default AnalyticsRouteTracker;